import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { FuncionesCarteraService } from './funciones-cartera.service';
import { Observable } from 'rxjs';
import { Estado } from './estados.cartera';

@Injectable({
  providedIn: 'root'
})

export class CarteraService {

  /**
   * Constructor
   * @param {HttpClient} _http 
   * @param {FuncionesCarteraService} _funcion
   */
  constructor(private _http:HttpClient, private _funcion: FuncionesCarteraService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Post
  // -----------------------------------------------------------------------------------------------------

  /* envia el sms al numero y con la descripcion que le hayan pasado por parametro */
  public enviarsms(numero, descripcion) {
    return this._http.post(`${environment.api}sms/enviarMensaje/`, { numeros: numero, mensaje: descripcion })
  }

  public GuardarLlamada(infoLlamada: any){
    return this._http.post(`${environment.api}cartera/llamada`, infoLlamada);
  }

  public GuardarCobro(form: any){
    return this._http.post(`${environment.api}cartera/guardar-cobro`, form);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Put
  // -----------------------------------------------------------------------------------------------------

  public GuardarDebitoAuto(debitoAuto, grupo_rad, grupo_doc, empresa){
    return this._http.put(`${environment.api}cartera/debito-auto/${grupo_doc}/${grupo_rad}/${empresa}`,{ debitoAuto});
  }

  public GuardarTipoFactura(factura_fis, factura_elect, grupo_rad, grupo_doc, empresa){
    return this._http.put(`${environment.api}cartera/tipo-factura/${grupo_doc}/${grupo_rad}/${empresa}`, {factura_fis, factura_elect});
  }

  public GuardarReprogramacion(form, id_cobro){
    return this._http.put(`${environment.api}cartera/reprogramacion/${id_cobro}`, form);
  }
  
  public editargurcel(numero, radicado){
    return this._http.put(`${environment.api}cartera/celular/${numero}/${radicado}`,{})
  }

  public AgregarCobroFijo(database, grunit, grugru, data){
    return this._http.put(`${environment.api}cartera/cobro-fijo/${grunit}/${grugru}/${database}`, data);
  }

  public QuitarCobroFijo(database, grunit, grugru, usuario){
    return this._http.put(`${environment.api}cartera/delete-cfijo/${grunit}/${grugru}/${database}`, {usuario});
  }

  public ReportePago(cobro: string, infoPago: any){
    return this._http.put(`${environment.api}cartera/cobro/${cobro}`, infoPago);
  }

  public ActualizarCobro(formulario){
    return this._http.put(`${environment.api}cartera/editar-cobro`, formulario);
  }

  public ActualizarObsGrupo(database, grunit, grugru, observacion_cartera, observacion_contrato){
    return this._http.put(`${environment.api}cartera/editar-obs-grupo/${grunit}/${grugru}/${database}`, {observacion_cartera, observacion_contrato});
  }

  public ActualizarEstadoSMS(grugru, estado){
    return this._http.put(`${environment.api}cartera/editar-estado-sms/${grugru}`, {estado});
  }

  public ActualizarCobrador(fechaCobro, ID_grupo, ID_cobro, form){
    return this._http.put(`${environment.api}cartera/update-cobrador/${fechaCobro}/${ID_grupo}/${ID_cobro}`, form);
  }

  public OrdenCobro(cobro: string, form){
    return this._http.put(`${environment.api}cartera/orden-cobro/${cobro}`, form);
  }

  public EditarObsCobro(fecha: string, ID_grupo: string, ID_cobro: string, observacion: string){
    return this._http.put(`${environment.api}cartera/update-obs-cobro/${fecha}/${ID_grupo}/${ID_cobro}`, {observacion});
  }

  public EditarFechasContrato(base_datos: string, grunit: string, data){
    return this._http.put(`${environment.api}cartera/update-fechas-contrato/${base_datos}/${grunit}`, data);
  }

  public CambiarEstadoCobro(id_cobro: number, form){
    return this._http.put(`${environment.api}cartera/update-estado-cobro/${id_cobro}`, form);
  }

  public AgregarNumFactura(id_cobro: number, form){
    return this._http.put(`${environment.api}cartera/update-numero-factura/${id_cobro}`, form);
  }

  public AgregarRadicadoAsoc(data: any){
    return this._http.put(`${environment.api}cartera/update-radicado-asoc`, data);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Get
  // -----------------------------------------------------------------------------------------------------

  public VerInfoGrupo(grupo_rad, grupo_doc, empresa){
    return this._http.get(`${environment.api}cartera/info-grupo/${grupo_doc}/${grupo_rad}/${empresa}`).pipe(map((response: any) => {
      (response.length? response[0]['tipo_factura'] = this._funcion.tipoFactura(response[0]['factura_elec'],response[0]['factura_fisica']) : '');
      return response;
    }));
  }

  //Estados de cobro que se pueden re agendar
  public reagendables(){
    return this._http.get(`${environment.api}cartera/codigos/reagendables`);
  }


  public VerCobrosCalendario(){
    return this._http.get(`${environment.api}cartera/cobros-calendario`);
  }

  public VerCobradores(){
    return this._http.get(`${environment.api}cartera/cobradores`);
  }

  public VerFacturasxGrupo(grupo_rad, grupo_doc, rad_asociado, empresa){
    return this._http.get(`${environment.api}cartera/facturas-grupo/${grupo_doc}/${grupo_rad}/${rad_asociado}/${empresa}`).pipe(map((response: any) => {
      return this._funcion.Facturas(response);
    }));
  }

  public verCobrosCartera(fecha_inicio, fecha_final, empresa, cobrador, estado, ciclo){
    return this._http.get(`${environment.api}cartera/cartera-cobros/${fecha_inicio}/${fecha_final}/${empresa}/${cobrador}/${estado}/${ciclo}`);
  }

  public VerNombreGrupo(form){
    return this._http.get(`${environment.api}cartera/busqueda-nombre/${form}`);
  }

  public VerBitacoraGrupo(base_datos, codigo){
    return this._http.get(`${environment.api}cartera/bitacora-grupo/${base_datos}/${codigo}`);
  }

  public VerServiciosTotalesxGrupo(base_datos, codigo){
    return this._http.get(`${environment.api}cartera/servicios-grupo/${base_datos}/${codigo}`);
  }

  public VerLlamadasBitacora(factura, grupo){
    return this._http.get(`${environment.api}cartera/llamadas-bitacora/${factura}/${grupo}`);
  }

  public VerHistorialCobros(grunit, grugru){
    return this._http.get(`${environment.api}cartera/historial-cobros/${grunit}/${grugru}`);
  }

  public VerCantRetiros(codigo, empresa){
    return this._http.get(`${environment.api}cartera/cantidad-retiros/${empresa}/${codigo}`);
  }

  public VerFacturasAtrasadas(empresa, grunit, grugru){
    return this._http.get(`${environment.api}cartera/facturas-atrasadas/${empresa}/${grunit}/${grugru}`);
  }

  public VerHistoricoFacturasxGrupo(empresa, grunit, grugru){
    return this._http.get(`${environment.api}cartera/historico-facturas-grupo/${empresa}/${grunit}/${grugru}`);
  }

  /* trae la informacion de smspredefinidos donde los mensajes pertenescan a cartera */
  public smsProgramarCobros() {
    return this._http.get(`${environment.api}cartera/smsProgramarCobros`);
  }

  public VerCobrosCobradorxDia(fecha){
    return this._http.get(`${environment.api}cartera/cobros-cobrador-x-dia/${fecha}`);
  }

  public verGruposxCobrosFijos(ciclo?: string){
    return this._http.get(`${environment.api}cartera/grupos-x-cobros-fijos/${(ciclo? ciclo : '0')}`)
                      .pipe(map((response: any) => {
                        response.forEach(element => {
                          element['tipo_factura'] = this._funcion.tipoFactura(element['factura_elect'], element['factura_fis']);
                        });
                        return response;
                      }));
  }

  public verUltimoCobro(database, grunit, grugru){
    return this._http.get(`${environment.api}cartera/ultimo-cobro/${database}/${grunit}/${grugru}`)
                      .pipe(map((response: any) => {
                        return this._funcion.filtroUltimoCobro(response);
                      }));
  }

  public VerObservacionesGrupo(database, grunit, grugru){
    return this._http.get(`${environment.api}cartera/observacion-grupo/${database}/${grunit}/${grugru}`);
  }

  public VerEstadoSMSGrupo(grugru,empresa){
    return this._http.get(`${environment.api}cartera/sms-estado/${grugru}/${empresa}`);
  }

  public VerHistorialReprogramacion(cobro: string){
    return this._http.get(`${environment.api}cartera/historial-reprogramacion/${cobro}`);
  }

  public EquivocacionCobro(cobro, data){
    return this._http.put(`${environment.api}cartera/equivocacion-cobro/${cobro}`, data);
  }

  public VerRadicados(base_datos: string){
    return this._http.get(`${environment.api}cartera/radicados/${base_datos}`);
  }

  public CobroRestringido(fecha: string, grunit: string, grugru: string){
    return this._http.get(`${environment.api}cartera/cobro-restringido/${grunit}/${grugru}/${fecha}`);
  }

  public VerEstadosCobro(){
    return this._http.get(`${environment.api}cartera/estado-cobro`);
  }

  public VerBeneficiariosxGrupo(grunit: string, grugru: string,db:string){
    return this._http.get(`${environment.api}cartera/beneficiarios-x-grupo/${grunit}/${grugru}/${db}`);
  }

  public VerFechasContratoxGrupo(grunit: string, database: string){
    return this._http.get(`${environment.api}cartera/fechas-contrato/${database}/${grunit}`);
  }

  public VerGruposAsociar(base_datos: string, filtro: number, data){
    return this._http.get(`${environment.api}cartera/grupos-asociacion/${base_datos}/${filtro}/${data}`);
  }

  public VerAgendadores(){
    return this._http.get(`${environment.api}cartera/agendadores`);
  }

  public verCarteraCobros(form){
    return this._http.post(`${environment.api}cartera/cartera-cobros`, form);
  }

  public verAuditoriaCobros(){
    return this._http.get(`${environment.api}cartera/auditoria-cobros`)
                    .pipe(map((response: Array<any>) => {
                        //Arreglo para devolver la respuesta
                        let final = [];
                        // Separamos los ids de los cobros
                        let cobros: Array<any> = response.map((data: any) => {
                            return data.cobro;
                        });
                        //Quitamos los duplicados en una sola variable así solo tendremos ids únicos y buscaremos sus estados 
                        const NCobros = new Set(cobros);
                        //Iteramos cada uno de los cobros
                        NCobros.forEach((cobro)=>{
                            //Buscamos los cobros relacionados al id que está siendo iterado
                            let cobrosRelacionados = response.filter((item)=>{
                                //Condición de filtro
                                return item.cobro === cobro;
                            })
                            //Guardamos SÓLO los estados de cobro para así reformatear el objeto
                            let estadosDelCobro = cobrosRelacionados.map(item=>{return {EstadoCobro:item.EstadoCobro,Nombre_estado:item.Nombre_estado}});
                            //Buscamos la informacion del cobro
                            let informacionDelCobro = response.find((item)=>item.cobro === cobro);
                            //Destructuramos la informacion del cobro y agregamos sus estados
                            final.push({...informacionDelCobro,estados:estadosDelCobro});
                        });
                        return final;
                    }));
  }

  setAltDir(dir,cobro){
    return this._http.put(`${environment.api}cartera/direcciones/alternativa/${cobro}`,{dir})
  }

  getEstados():Observable<Array<Estado>>{
    return this._http.get<Array<Estado>>(`${environment.api}cartera/estados`);
  }

  getEstadosDiligencias():Observable<Array<Estado>>{
    return this._http.get<Array<Estado>>(`${environment.api}cartera/estados/diligencias`);
  }
}